import React, {useState, useRef, useLayoutEffect, useEffect} from 'react';
import axios from 'axios';
import {useLocalStorage} from 'react-use';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap'

import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";

// react component used to create alerts
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

const localizer = momentLocalizer(moment);

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default function Agenda() {

  const [swal, setSwal] = useAlert();
  const [events, setEvents] = useState([]);
  const [timeMin, setTimeMin] = useState(moment().startOf('month').toISOString());
  const [timeMax, setTimeMax] = useState(moment().endOf('month').toISOString());
  const [auth] = useLocalStorage('authenticated');

  const eventColors = (event, start, end, isSelected) => {
    var backgroundColor = "rbc-event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
  };

  const fetchEvents = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}calendars`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          email: auth.employee.EMP_EMAIL,
          timeMin,
          timeMax,
        }
      }
    );

    setEvents(response.data);
  }

  const handleRangeChange = e => {
    setTimeMin(moment(e.start).toISOString());
    setTimeMax(moment(e.end).toISOString())
  }

  const CustomToolbar = (props) => {
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button type="button" onClick={() => props.onNavigate("PREV")}>‹</button>
          <button type="button" onClick={() => props.onNavigate("TODAY")}>Today</button>
          <button type="button" onClick={() => props.onNavigate("NEXT")}>›</button>
        </span>
        <span className="rbc-toolbar-label">
          {console.log(props.date)}
        </span>
        <span className="rbc-btn-group">
          <button type="button" onClick={() => props.onView("month")}>Month</button>
          <button type="button" onClick={() => props.onView("week")}>Week</button>
          <button type="button" onClick={() => props.onView("day")}>Day</button>
          <button type="button" onClick={() => props.onView("agenda")}>Agenda</button>
        </span>
      </div>
    );
  };






  useEffect(() => {
    fetchEvents();
  }, [timeMin, timeMax]);

  return (
    <Container fluid>
      <Breadcrumb>
        <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          Agenda
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Calendar
        </Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md="12">
          <Card>
            <Card.Body>
              <BigCalendar
                selectable
                onRangeChange={handleRangeChange}
                localizer={localizer}
                events={events}
                defaultView="month"
                scrollToTime={new Date(1970, 1, 1, 6)}
                defaultDate={new Date()}
                onSelectSlot={(slotInfo) => addNewEventAlert(slotInfo)}
                eventPropGetter={eventColors}
                // components={{
                //   toolbar: CustomToolbar,
                // }}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md="4"></Col>
      </Row>
    </Container>
  )
}